module.exports = __webpack_public_path__ + "static/img/logo-smile.52a7d95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-smile.svg
// module id = 4lMh
// module chunks = 1